import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

import Navbar from "./navbar";

const pages = ["Home", "About", "Projects", "Contact" ]

const Header = ({ siteTitle }) => (
  <header
    style={{
      background: `#f4c542`,
      marginBottom: `1.45rem`,
    }}
  >
    <div
      style={{
        margin: `0 auto`,
        maxWidth: 960,
        padding: `1.45rem 1.0875rem`,
      }}
    >
      <Link to="/">
        <h1 className="sitetitle">
          {siteTitle}
        </h1>
      </Link>
        <Navbar pages={pages}/>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
